import SeoHead from '@/components/base/SeoHead';
import Navbar from '@/components/feature/Navbar';
import Hero from '@/components/feature/Hero';
import AboutSection from '@/components/feature/AboutSection';
import CategoryGrid from '@/components/feature/CategoryGrid';
import SeoArticlesHub from '@/components/feature/SeoArticlesHub';
import CtaSection from '@/components/feature/CtaSection';
import TestimonialSection from '@/components/feature/TestimonialSection';
import Footer from '@/components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL;

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Oopbuyspreadsheet',
    url: siteUrl,
    description: 'The ultimate oopbuy spreadsheet tracking and cost management system for smart buyers.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Oopbuyspreadsheet',
    url: siteUrl,
    description: 'Oopbuyspreadsheet provides smart spreadsheet tracking systems for fashion buyers, sneaker resellers, and bulk sourcing professionals.',
  },
];

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <SeoHead
        title="Oopbuyspreadsheet - Master Your Purchases with Smart Spreadsheet Tracking System"
        description="Discover oopbuyspreadsheet, the ultimate oopbuy spreadsheet system for tracking purchases, managing orders, and optimizing costs. Free templates, guides, and tools for smart fashion buyers, sneaker resellers, and bulk sourcing professionals."
        keywords="oopbuyspreadsheet, oopbuy spreadsheet, oopbuy spreadsheets, spreadsheet tracking system, oopbuy order tracking, cost management spreadsheet, fashion buyer spreadsheet, bulk order spreadsheet"
        canonicalUrl={siteUrl}
        ogTitle="Oopbuyspreadsheet - Master Your Purchases with Smart Spreadsheet Tracking System"
        ogDescription="Discover oopbuyspreadsheet, the ultimate oopbuy spreadsheet system for tracking purchases, managing orders, and optimizing costs. Free templates, guides, and tools for smart buyers."
        ogUrl={siteUrl}
        ogType="website"
        twitterCard="summary_large_image"
        twitterTitle="Oopbuyspreadsheet - Smart Spreadsheet Tracking System"
        twitterDescription="Master your purchases with oopbuyspreadsheet. Free templates, tracking guides, and cost optimization tools for smart buyers."
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <Hero />
      <AboutSection />
      <CategoryGrid />
      <SeoArticlesHub />
      <CtaSection />
      <TestimonialSection />
      <Footer />
    </main>
  );
}